import { Navigate, Outlet } from "react-router-dom";
import { Loading } from "../../components/ui";
import { useOrganization } from "../../contexts/OrganizationContext";

interface AgentAccessGuardProps {
    restrictedAgent: "hr" | "law";
}

const AgentAccessGuard = ({ restrictedAgent: _restrictedAgent }: AgentAccessGuardProps): JSX.Element => {
    const { canAdminister, loading } = useOrganization();

    if (loading) {
        return <Loading size="standard" label="Loading access..." />;
    }

    return canAdminister ? <Outlet /> : <Navigate to="/app/agent" replace />;
};

export default AgentAccessGuard;
